import { StateNode, TLStateNodeConstructor } from "tldraw"
import { CustomDrawing } from "./CustomDrawing"
import { DrawFillIdle } from "./DrawFillIdle"
import { DrawingFill } from "./DrawingFill"

export class DrawFillTool extends StateNode {
  static override id = "draw-fill"
  static override initial = "draw-fill-idle"
  static override isLockable = false
  static override children(): TLStateNodeConstructor[] {
    return [DrawFillIdle, DrawingFill]
  }

  override shapeType = "custom-draw"

  override onExit() {
    const drawingState = this.children!["drawing-fill"] as CustomDrawing
    drawingState.initialShape = undefined
  }
}
